import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'currencyPipe'})

export class CurrencyPipe implements PipeTransform {

  transform(value: string): string {
    let map: Map<string, string> = new Map([
        ['EUR', "€"],
        ['USD', "$"],
      ])
      return (map.get(value)) || "€";
  }
}